import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { StatusToColor } from './status-to-color.pipe';

@NgModule({
    declarations: [StatusToColor],
    imports: [IonicModule],
    exports: [StatusToColor]
  })
  export class PipesModule { }